import React, { forwardRef, useImperativeHandle, useRef } from "react";
import html2pdf from "html2pdf.js";
import { Col, Image, Row } from "antd";
import "./index.css";
import Logo1 from "../../assets/images/Logo.jpg";
import Logo2 from "../../assets/images/footer-img-6.jpg";
import { CheckOutlined, CloseOutlined, Hotel } from "@mui/icons-material";
import PropTypes from "prop-types";
import { FaCaretRight, FaHotel, FaLocationDot, FaPlus } from "react-icons/fa6";
import { FiMail } from "react-icons/fi";
import { FaMinus, FaPhone } from "react-icons/fa";

// Utility style for each PDF page
const pageStyle = {
  padding: "40px",
  fontFamily: "Poppins",
  fontSize: "13px",
  color: "#000",
  backgroundColor: "#fff",
  width: "100%",
  height: "100%",
  pageBreakAfter: "always",
  ontFamily: "Poppins",
};
const itinerariesPageStyle = {
  padding: "40px",
  fontFamily: "Poppins",
  fontSize: "13px",
  color: "#000",
  backgroundColor: "#fff",
  width: "100%",
  height: "100%",
  ontFamily: "Poppins",
  //   pageBreakAfter: "always",
};

const sectionHeader = {
  color: "#eb3e43", // Tailwind red-700
  fontSize: "20px",
  fontWeight: "bold",
  marginBottom: "10px",
  fontFamily: "Poppins",
  width: "100%",
  backgroundColor: "linear-gradient(45degree, red 90%, white 10%)",
};

const TourPDFContent = forwardRef((props, ref) => {
  const pdfRef = useRef();

  useImperativeHandle(ref, () => ({
    downloadPDF() {
      const options = {
        margin: 0,
        filename: "tour-itinerary.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "pt", format: "a4", orientation: "landscape" },
      };
      //   if (imageReady) {
      html2pdf().set(options).from(pdfRef.current).save();
      //   }
    },
  }));

  // console.log(props, "props from pdf");

  const itineryArray =
    props.data &&
    props.data.itineraries !== undefined &&
    props.data.itineraries.length > 0
      ? props.data.itineraries
      : [];

  // const itinerariesFinalArray =
  //   itineryArray && itineryArray.length > 0 ? chunkArray(itineryArray) : [];

  // console.log(itinerariesFinalArray, "itinerariesFinalArray");
  const badgeStyle = {
    backgroundColor: "#eb3e43",
    color: "#fff",
    padding: "6px 14px",
    borderRadius: "4px 0 0 4px",
    fontWeight: "bold",
    // writingMode: "vertical-rl",
    // transform: "rotate(180deg)",
    minWidth: "50px",
    textAlign: "center",
    fontSize: "13px",
    marginRight: "10px",
    ontFamily: "Poppins",
  };

  const boxStyle = {
    borderLeft: "10px solid #eb3e43",
    borderRight: "1px solid #eb3e43",
    borderTop: "1px solid #eb3e43",
    borderBottom: "1px solid #eb3e43",
    padding: "16px",
    fontSize: "13px",
    // lineHeight: "1.6",
    width: "105%",
    fontFamily: "Poppins",
  };
  const rowStyle = {
    display: "flex",
    alignItems: "flex-start",
    ontFamily: "Poppins",
    marginBottom: "24px",
  };

  // const footerStyle = {
  //   position: "absolute",
  //   bottom: "100px",
  //   left: "50px",
  //   width: "90%",
  //   textAlign: "center",
  //   fontSize: "12px",
  //   backgroundColor: "#eb3e43",
  //   color: "#fff",
  //   padding: "10px 8px",
  // };

  // console.log(itineryArray, "itineryArray");

  //   const itineraryHtml = `
  //   <div style="
  //     display: flex;
  //     flex-direction: column;
  //     justify-content: space-between;
  //     font-family: Arial, sans-serif;
  //     font-size: 13px;
  //     padding: 40px;
  //     box-sizing: border-box;
  //     page-break-after: always;
  //   ">
  //     <div>
  //       <h2 style="color: #0073cf; font-weight: bold; font-size: 20px; margin-bottom: 24px;">
  //         Daywise Itinerary
  //       </h2>

  //       ${renderDayBox(
  //         1,
  //         "Arrival in Chandigarh",
  //         [
  //           "Welcome to Chandigarh and transfer to the hotel.",
  //           "Check into your hotel and relax.",
  //           "Half day city tour, visiting the below attractions:",
  //           "- Sukhna Lake (popular lake)",
  //           "- Rock Garden (unique sculpture garden)",
  //           "- Elante Mall (shopping hub)",
  //           "Savor the flavors of Chandigarh in Sector 17 market.",
  //           "Dinner and overnight stay in Chandigarh at the hotel.",
  //         ],
  //         [
  //           "Pls. Schedule Flight Arrival in Chandigarh Latest By 1200 Hrs to board the Common Group transfers at 1300 hrs from Chandigarh Airport",
  //           "Taxis from Airport OR Train From Chandigarh Airport / Railway Station (Guest on their Own)",
  //           "Pre-book Cab With Us on Extra supplement",
  //         ]
  //       )}

  //       ${renderDayBox(2, "Chandigarh to Manali (300 Km / ~ 09 hours drive)", [
  //         "Morning Breakfast at the hotel.",
  //         "Drive to Manali (a popular Himalayan resort town known for its adventure activities and natural beauty)",
  //         "Check into the hotel and relax.",
  //         "Dinner and overnight stay in Manali at the hotel.",
  //       ])}
  //     </div>

  //     <div style="text-align: center; font-size: 12px; color: #777; border-top: 1px solid #ccc; padding-top: 6px;">
  //       www.planmitrip.in
  //     </div>
  //   </div>
  // `;

  const StarRating = ({ rating }) => {
    return (
      <div style={{ fontSize: "24px", color: "#f1c40f" }}>
        {"★".repeat(rating)}
      </div>
    );
  };

  // const urlToFile = async (imageUrl) => {
  //   const res = await fetch(imageUrl, { mode: "no-cors" });
  //   const blob = await res.blob();

  //   // Extract filename from URL
  //   const urlParts = imageUrl.split("/");
  //   const rawFilename = urlParts[urlParts.length - 1].split("?")[0]; // Remove query params if any

  //   // Guess MIME type
  //   const extension = rawFilename.split(".").pop().toLowerCase();
  //   const mimeType =
  //     extension === "png"
  //       ? "image/png"
  //       : extension === "jpg" || extension === "jpeg"
  //       ? "image/jpeg"
  //       : "application/octet-stream";

  //   const filename = rawFilename || "image.png";

  //   return new File([blob], filename, { type: mimeType });
  // };
  // const yourDynamicImageUrl = !isEmpty(props.packageDetailsData)
  //   ? props.packageDetailsData.imageUrl
  //   : "";
  // const [imageFile, setImageFile] = useState("");
  // useEffect(() => {
  //   let isMounted = true;
  //   const fetchImage = async () => {
  //     try {
  //       const res = await fetch(yourDynamicImageUrl, { mode: "no-cors" });
  //       const blob = await res.blob();

  //       const filename = yourDynamicImageUrl.split("/").pop().split("?")[0];
  //       const extension = filename.split(".").pop().toLowerCase();
  //       const mimeType =
  //         extension === "png"
  //           ? "image/png"
  //           : extension === "jpg" || extension === "jpeg"
  //           ? "image/jpeg"
  //           : "application/octet-stream";

  //       if (isMounted) {
  //         const file = new File([blob], filename, { type: mimeType });
  //         setImageFile(file);
  //       }
  //     } catch (error) {
  //       console.error("Image fetch failed:", error);
  //     }
  //   };
  //   fetchImage();
  //   return () => {
  //     isMounted = false;
  //   };
  // }, [yourDynamicImageUrl]);

  // console.log(imageFile, "imageFile");
  //   const { base64 } = useBase64Image(yourDynamicImageUrl);

  // console.log(yourDynamicImageUrl, "yourDynamicImageUrl");
  return (
    <div style={{ display: "none" }}>
      <div ref={pdfRef} id={props && props.id}>
        {/* Page 1: Tour Title */}
        <div style={pageStyle}>
          <div className="h-[80px] bg-[#eb3e43]">
            <Image
              src={Logo1}
              className="mt-2 ml-3"
              preview={false}
              height={60}
              width={155}
            />
          </div>
          {/* <Image
            src={imageFile !== undefined ? imageFile : ""}
            // preview={false}
            width={"100%"}
            className="rounded-xl border border-solid rounded-md"
            height={"360"}
            // style={{
            //   backgroundSize: "cover",
            // }}
          /> */}
          {/* <img
            src={
              !isEmpty(props.packageDetailsData)
                ? props.packageDetailsData.imageUrl
                : ""
            }
            alt="no-img"
            crossorigin="anonymous"
            //   style={{ display: "none" }}
            className="border border-solid rounded-md"
            onLoad={() => setImageReady(true)}
            onError={() => setImageReady(false)}
          /> */}
          <h1 style={{ ...sectionHeader, fontSize: "24px" }}>
            {props.data && props.data.packageName ? props.data.packageName : ""}
          </h1>
          <p style={{ fontSize: "16px", marginBottom: "20px" }}>
            Package starts from ₹
            {props.data && props.data.lowestPrice ? props.data.lowestPrice : 0}{" "}
            <br />{" "}
            {props.data && props.data.totalDayAndNight
              ? props.data.totalDayAndNight
              : ""}
          </p>
          {/* <ul>
            <li>
              <strong>Shimla:</strong> 2 Nights
            </li>
            <li>
              <strong>Manali:</strong> 3 Nights
            </li>
            <li>
              <strong>Chandigarh:</strong> 1 Night
            </li>
          </ul> */}
          <div className="mt-[460px] w-[98%] text-center bg-red-500 text-white text-xs py-2">
            www.planmitrip.in
          </div>
        </div>

        {/* Page 2: Daywise Itinerary */}

        <div style={pageStyle}>
          <div className="flex text-[18px] font-semibold text-[#eb3e43] pl-5">
            Day Wise Itineraries <FaLocationDot className="text-[35px] ml-1" />
          </div>
          {itineryArray.map((item, index) => {
            return (
              <div key={index} style={itinerariesPageStyle}>
                {/* First item of the pair */}
                <div style={rowStyle}>
                  <div style={badgeStyle}>
                    <p className="mt-[-8px]">Day {item.day}</p>
                  </div>

                  <div style={boxStyle}>
                    {/* <div className="h-[100%] w-[20px] bg-[#eb3e43]"></div> */}
                    <h1 className="text-[#eb3e43] mb-2">
                      {item.destinationDetails &&
                      item.destinationDetails.length > 0
                        ? item.destinationDetails[0].destinationName
                        : ""}
                    </h1>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item ? item.description : "",
                      }}
                    />
                  </div>
                </div>
                {/* Second item of the pair, if it exists */}
                {/* {item[index + 1] && (
                  <div style={rowStyle}>
                    <p className="mt-[-4px]">Day {item[index + 1].day}</p>

                    <div
                      style={boxStyle}
                      dangerouslySetInnerHTML={{
                        __html: item ? item[index + 1].description : "",
                      }}
                    />
                  </div>
                )} */}
              </div>
            );
          })}
          <div className="absolute -bottom-90 l42t-10 w-[98%] text-center bg-red-500 text-white text-xs py-2">
            <p className="mt-[-3px]">www.planmitrip.in</p>
          </div>
        </div>
        <div style={pageStyle}>
          <div className="flex text-[18px] font-semibold text-[#eb3e43]">
            Accommodation <FaHotel className="text-[40px] ml-1" />
          </div>
          {props.data &&
          props.data.overAllHotels &&
          props.data.overAllHotels !== undefined &&
          props.data.overAllHotels.length > 0 ? (
            itineryArray.map((slide, index) => {
              //   const imageUrl =
              //     slide && slide.images.length > 0 ? slide.images[0] : "";
              const accommodations =
                slide && slide.accomodations.length > 0
                  ? slide.accomodations[0]
                  : "";
              const hotelDetails =
                accommodations !== "" &&
                accommodations.hotelDetails &&
                accommodations.hotelDetails !== undefined
                  ? accommodations.hotelDetails
                  : "";
              const itineraryIndex = index + 1;
              const itineryLength =
                itineryArray && itineryArray.length > 1
                  ? parseFloat(itineryArray.length - 1)
                  : 0;
              return (
                <Row
                  key={index}
                  className="h-[100%] pt-4 pb-5 border border-dotted border-x-0 border-t-0 border-2"
                >
                  <Col
                    md={14}
                    sm={24}
                    xs={24}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="pl-4"
                  >
                    <Row>
                      <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
                        <div className="flex w-[100%] input-label text-[13px]">
                          <h1 className="font-semibold text-[15px] flex">
                            {hotelDetails && hotelDetails.length > 0
                              ? hotelDetails[0].destinationName
                              : hotelDetails &&
                                hotelDetails.length > 0 &&
                                hotelDetails[0].hotelName !== undefined
                              ? "" + "-" + hotelDetails[0].hotelName
                              : ""}{" "}
                            <p className="ml-2 text-[15px]">
                              {accommodations &&
                              accommodations.facilityTypeName !== undefined &&
                              hotelDetails &&
                              hotelDetails.length > 0
                                ? " - " + accommodations.facilityTypeName
                                : // : accommodations &&
                                  //   accommodations.facilityTypeName !== undefined
                                  // ? accommodations.facilityTypeName
                                  ""}
                            </p>
                          </h1>
                          {/* <p className="ml-2 mr-2">
                                                                    {"|"}
                                                                  </p>
                                                                  <p className="">
                                                                    {slide.ratings}
                                                                  </p> */}
                        </div>
                      </Col>
                      <Col
                        md={24}
                        sm={24}
                        xs={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        className="flex"
                      >
                        <div className="flex input-label text-[13px] mr-4">
                          <p className="">
                            <StarRating
                              rating={
                                hotelDetails && hotelDetails.length > 0
                                  ? hotelDetails[0].ratings
                                  : ""
                              }
                            />
                          </p>
                        </div>
                        <div className="mt-3 text-[15px] flex input-label text-[13px]">
                          {hotelDetails && hotelDetails.length > 0 ? (
                            <p className="mr-2">|</p>
                          ) : (
                            ""
                          )}

                          <p
                            className=""
                            dangerouslySetInnerHTML={{
                              __html:
                                hotelDetails && hotelDetails.length > 0
                                  ? hotelDetails[0].address
                                  : "",
                            }}
                          ></p>
                        </div>
                      </Col>
                      <div className="mt-3 text-[15px] flex input-label text-[13px]">
                        <p className="mr-2 text-[#eb3e43]">
                          {hotelDetails && hotelDetails.length > 0
                            ? "Destination:"
                            : ""}
                        </p>

                        <p className="text-[#eb3e43]">
                          {slide &&
                          slide.destinationDetails.length > 0 &&
                          itineryLength === itineraryIndex
                            ? slide.destinationDetails[0].destinationName +
                              " - " +
                              `${parseFloat(itineryArray.length - 1)} Nights`
                            : slide &&
                              slide.destinationDetails.length > 0 &&
                              itineryArray.length < 1 &&
                              itineryArray
                            ? slide.destinationDetails[0].destinationName
                            : ""}
                        </p>
                      </div>
                    </Row>
                  </Col>
                </Row>
              );
            })
          ) : (
            <div className="text-center images-label">No Images found</div>
          )}
          <div className="mt-[370px] w-[98%] text-center bg-red-500 text-white text-xs py-2">
            www.planmitrip.in
          </div>
        </div>
        {/* Page 3: Inclusions */}
        <div style={pageStyle} className="h-[100%] bg-[#eb3e43]">
          <div className="flex text-[18px] font-semibold text-[#eb3e43]">
            <h1 className="mr-3"> Tour Inclusions </h1>
            <FaPlus className="border rounded-3xl border-1 text-[30px]" />
          </div>
          <Col
            md={12}
            sm={12}
            xs={12}
            lg={12}
            xl={12}
            xxl={12}
            className="package-fonts h-[100%] pr-3"
          >
            <div className="w-[100%] bg-[#30d16e30] border border-1 rounded-xl shadow-md p-2 mt-3 pb-2">
              <div className="w-[100%] flex pb-1">
                <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                <h1 className="text-[16px] font-semibold">Inclusions</h1>
              </div>
              <div className="ml-1 mt-1">
                {props &&
                props.data &&
                props.data.inclusion !== undefined &&
                props.data.inclusion.length > 0
                  ? props.data.inclusion.map((data, index) => {
                      return (
                        <div key={index} className="mb-1 flex">
                          <p>
                            <CheckOutlined className="text-[green] text-[12px]" />
                          </p>
                          <h1 className="text-[11px] ml-2 mt-[2px]">{data}</h1>
                        </div>
                      );
                    })
                  : ""}
              </div>
            </div>
          </Col>
          <div className="mt-[460px] w-[98%] text-center bg-red-500 text-white text-xs py-2">
            www.planmitrip.in
          </div>
        </div>
        <div style={pageStyle} className="relative bg-[#eb3e43]">
          <div className="flex text-[18px] font-semibold text-[#eb3e43]">
            <h1 className="mr-3">Tour Exclusions </h1>
            <FaMinus className="border rounded-3xl border-1 mt-1 text-[30px]" />
          </div>
          <Col
            md={12}
            sm={12}
            xs={12}
            lg={12}
            xl={12}
            xxl={12}
            className="package-fonts h-[100%] pr-3"
          >
            <div className="w-[100%] bg-[#e95d5d1f] border border-1 rounded-xl shadow-md p-2 mt-3 pb-2">
              <div className="w-[100%] flex pb-1">
                <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                <h1 className="text-[16px] font-semibold">Exclusions</h1>
              </div>
              <div className="ml-1 mt-1">
                {props.data &&
                props.data.exclusion !== undefined &&
                props.data.exclusion.length > 0
                  ? props.data.exclusion.map((data, index) => {
                      return (
                        <div key={index} className="mb-1 flex">
                          <p>
                            <CloseOutlined className="text-[#eb3e43] text-[12px]" />
                          </p>
                          <h1 className="text-[11px] ml-2 mt-[2px]">{data}</h1>
                        </div>
                      );
                    })
                  : ""}
              </div>
            </div>
          </Col>
          <div className="mt-[460px] w-[98%] text-center bg-red-500 text-white text-xs py-2">
            www.planmitrip.in
          </div>
        </div>

        {/* Page 4: Accommodation */}
        {/* <div style={pageStyle}>
          <div style={sectionHeader}>Accommodation</div>
          <ul>
            <li>
              <strong>Shimla:</strong> Manla Homes Resort or similar
            </li>
            <li>
              <strong>Manali:</strong> Grace Resort and Spa or similar
            </li>
            <li>
              <strong>Chandigarh:</strong> Sun Park Resort or similar
            </li>
          </ul>
          <div className="absolute -bottom-90 l42t-10 w-[98%] text-center bg-red-500 text-white text-xs py-2">www.planmitrip.in</div>
        </div> */}

        {/* Page 5: Optional Add-ons */}

        <div style={pageStyle}>
          <div className="text-[18px] font-semibold text-[#eb3e43]">Meals</div>
          <div className="w-[100%] bg-[white] border border-1 rounded-xl shadow-md p-2 mt-3 pb-2">
            <div className="w-[100%] flex mt-5 mb-5 pr-6">
              <h1 className="w-[80%] text-[13px] flex font-normal pr-6 pl-2">
                {props.data &&
                props.data.meals &&
                props.data.meals !== undefined ? (
                  <div className="flex">
                    <FaCaretRight className="mt-1 text-[#eb3e43] mr-1" />{" "}
                    <h1
                      dangerouslySetInnerHTML={{
                        __html: props.data.meals && props.data.meals,
                      }}
                      className="text-[13px] font-normal"
                    >
                      {/* {props.data.meals} */}
                    </h1>
                  </div>
                ) : (
                  ""
                )}
              </h1>
            </div>
          </div>
          <div className="mt-[490px] w-[98%] text-center bg-red-500 text-white text-xs py-2">
            www.planmitrip.in
          </div>
        </div>
        {/* Page 5: Optional Add-ons */}
        {/* <div style={pageStyle}>
          <div style={sectionHeader}>Optional Add-ons</div>
          <ul>
            <li>River Side Dinner with Bonfire – ₹9900/couple</li>
            <li>Jeep Safari Blue Mountain – ₹7200/couple</li>
            <li>Jeep Safari Hamta Pass – ₹5500/couple</li>
          </ul>
          <div className="absolute -bottom-90 l42t-10 w-[98%] text-center bg-red-500 text-white text-xs py-2">www.planmitrip.in</div>
        </div> */}

        {/* Page 6: Contact */}
        <div style={{ ...pageStyle, pageBreakAfter: "auto" }}>
          <div className="text-[18px] font-semibold text-[#eb3e43]">
            Contact & Support
          </div>
          <div className="flex justify-between mt-2">
            <p className="flex">
              <FiMail className="mr-2 rounded-3xl border bg-[lightgray] text-[50px]" />{" "}
              Email: online.business@planmitrip.in
            </p>
            <p className="flex">
              <FaPhone className="mr-2 rounded-3xl border bg-[lightgray] text-[50px]" />{" "}
              Toll-Free: 1800-209-3344
            </p>
          </div>
          <p style={{ fontSize: "12px", color: "#555", marginTop: "20px" }}>
            GST applicable as per current rates. Optional activities not
            included. Subject to group size.
          </p>
          <Image
            src={Logo2}
            preview={false}
            width={"50%"}
            height={170}
            className="mt-[30px]"
          />
          <div className="mt-[360px] w-[98%] text-center bg-red-500 text-white text-xs py-2">
            www.planmitrip.in
          </div>
        </div>
      </div>
    </div>
  );
});

TourPDFContent.propTypes = {
  data: PropTypes.any,
  id: PropTypes.any,
  packageDetailsData: PropTypes.any,
};

export default TourPDFContent;
